import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";

import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import {
  AutocompleteInput,
  CustomSelect,
  CustomSwitch,
  DateInput,
  FloatInput,
  IntInput,
  LocalizationAutocomplete,
  TextInput,
} from "components/Input/Index.js";
import { compte } from "variables/patrimoine.js";

import AdvancedSearchContext from "context/AdvancedSearchContext";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { updateAccountMeter,getFiles } from "services/ConfigServices";
import Tooltip from "@mui/material/Tooltip";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function EditUserDialog(props) {
  const currentusertype = localStorage.getItem('userType');
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const {
    energy,
    parameters,
    closeModal,
    refetch,
    meter,
    dsoData,
    utilitiesData,
    authorizationData,
    utilityauthorizationData,
 
  } = props;

  const [clef, setClef] = useState(meter.details.clef);
  const [meternumber, setMeternumber] = useState(meter.meternumber);
  const [name, setName] = useState(meter.details.name);
  const [options, setOptions] = useState([]);
  const [validatedAddress, setValidatedAddress] = useState(meter.details.validatedAddress || {});
  const loaded = useRef(false);
  const [status, setStatus] = useState(meter.details.status);
  const [serialnumber, setSerialnumber] = useState(meter.details.serialnumber);
  const [address, setAddress] = useState(meter.details.address || {});
  const [inputValue, setInputValue] = useState("");
  const [metersDso, setMetersDso] = useState(meter.details.dso);
  const [diameter, setDiameter] = useState(meter.details.diameter);
  const [acheminement, setAcheminement] = useState(meter.details.acheminement);
  const [monthlyconsumption, setMonthlyconsumption] = useState(meter.details.monthlyconsumption || false);
  const [dailyconsumption, setDailyconsumption] = useState(meter.details.dailyconsumption || false);
  const [loadcurve, setloadcurve] = useState(meter.details.loadcurve || false);
  const [contractualdata, setContractualdata] = useState(meter.details.contractualdata || false);
  const [associatedcontractid, setAssociatedcontractid] = useState(meter.details.associatedcontractid);
  const [comments, setComments] = useState(meter.details.comments);
  const [description, setDescription] = useState(meter.details.description);
  const [authorizationid, setAuthorizationid] = useState();
  const [usagecode, setUsagecode] = useState(meter.details.usagecode);
  const [utilitydata, setUtilitydata] = useState(meter.details.utilitydata || false);
  const [utilityauthorizationid, setUtilityauthorizationid] = useState(meter.details.utilityauthorizationid);
  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  const [ged, setGed] = useState(meter.details.ged || []);

  const handleClefChange = (e) => {
    setClef(e.target.value);
  };
  const handleMeternumberChange = (e) => {
    setMeternumber(e.target.value);
  };
  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };
  const handleSerialnumberChange = (e) => {
    setSerialnumber(e.target.value);
  };
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleDsoChange = (e) => {
    setMetersDso(e.target.value);
  };
  const handleDiameterChange = (e) => {
    setDiameter(e.target.value);
  };
  const handleAcheminementChange = (e) => {
    setAcheminement(e.target.value);
  };
  const handleMonthlyconsumptionChange = (e) => {
    setMonthlyconsumption(!monthlyconsumption);
  };
  const handleDailyconsumptionChange = (e) => {
    setDailyconsumption(!dailyconsumption);
  };
  const handleLoadcurveChange = (e) => {
    setloadcurve(!loadcurve);
  };
  const handleContractualdataChange = (e) => {
    setContractualdata(!contractualdata);
  };
  const handleAssociatedfilesChange = (newValue) => {
    setGed(newValue);
  };
  const handleAssociatedcontractidChange = (e) => {
    setAssociatedcontractid(e.target.value);
  };
  const handleCommentsChange = (e) => {
    setComments(e.target.value);
  };
  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };
  const handleAuthorizationidChange = (e) => {
    setAuthorizationid(e.target.value);
  };
  const handleUsagecodeChange = (e) => {
    setUsagecode(e.target.value);
  };
  const handleUtilitydataChange = (e) => {
    setUtilitydata(!utilitydata);
  };
  const handleUtilityauthorizationidChange = (e) => {
    setUtilityauthorizationid(e.target.value);
  };

  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;

    if (ged !== undefined) {
      for (let i = 0; i < ged.length; i++) {
        gedCardId.push(ged[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };

  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  const handleSubmit = async (event) => {
    const editedDetails = {
      ...meter.details,
      clef,
      status,
      serialnumber,
      name,
      address,
      validatedAddress,
      dso: metersDso,
      diameter,
      acheminement,
      monthlyconsumption,
      dailyconsumption,
      loadcurve,
      contractualdata,
      associatedcontractid,
      comments,
      description,
      ged,
      authorizationid,
      usagecode,
      utilityauthorizationid,
      utilitydata,
    }
    const editedMeter = {
      meternumber,
      uuid : meter.uuid,
      details : editedDetails,
    };

    axios
    .put(
      updateAccountMeter(meter.uuid,chartIdGroup,energy),
      editedMeter,
      {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          'Content-Type': "application/json; charset=utf-8",
        },
      }
    )
    .then(() => {
      closeModal();
      refetch();
    })
    .catch(() => { });
  };

  const statusData = [
    { name: "Actif", id: "on" },
    { name: "Résilié", id: "off" },
  ];

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].key}
                textInput={clef}
                handleTextInputChange={handleClefChange}
              />
            </div>
            {currentusertype == 1 ?
              <Tooltip title="Attention : la modification d'un numéro de compteur ne changera pas le numéro sur les compteurs distribués">
                <div>
                  <TextInput
                    inputTitle={compte.energy[energy][parameters].meternumber}
                    textInput={meternumber}
                    handleTextInputChange={handleMeternumberChange}
                  />
                </div>
              </Tooltip>
              :
              <div>
                <TextInput
                  inputTitle={compte.energy[energy][parameters].meternumber}
                  textInput={meternumber}
                  handleTextInputChange={handleMeternumberChange}
                  disabled={true}
                />
              </div>
            }
            <div>
              <CustomSelect
                inputTitle={compte.energy[energy][parameters].status}
                selectValue={status}
                handleSelectValueChange={handleStatusChange}
                data={statusData}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].serialnumber}
                textInput={serialnumber}
                handleTextInputChange={handleSerialnumberChange}
              />
            </div>
            <div>
              <LocalizationAutocomplete
                specialWidth="97%"
                inputTitle={compte.energy[energy][parameters].address}
                value={address}
                setValue={setAddress}
                inputValue={inputValue}
                setInputValue={setInputValue}
                options={options}
                setOptions={setOptions}
                setValidatedAddress={setValidatedAddress}
                validatedAddress={validatedAddress}
                loaded={loaded}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].dso}
                textInput={metersDso}
                handleTextInputChange={handleDsoChange}
              />
            </div>
            <div>
              <IntInput
                inputTitle={compte.energy[energy][parameters].diameter}
                intInput={diameter}
                handleIntInputChange={handleDiameterChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].acheminement}
                textInput={acheminement}
                handleTextInputChange={handleAcheminementChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={
                  compte.energy[energy][parameters].monthlyconsumption
                }
                checkedState={monthlyconsumption}
                handleSwitchChange={handleMonthlyconsumptionChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={compte.energy[energy][parameters].dailyconsumption}
                checkedState={dailyconsumption}
                handleSwitchChange={handleDailyconsumptionChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={compte.energy[energy][parameters].loadcurve}
                checkedState={loadcurve}
                handleSwitchChange={handleLoadcurveChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={compte.energy[energy][parameters].contractualdata}
                checkedState={contractualdata}
                handleSwitchChange={handleContractualdataChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={compte.energy[energy][parameters].utilitydata}
                checkedState={utilitydata}
                handleSwitchChange={handleUtilitydataChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={
                  compte.energy[energy][parameters].associatedcontractid
                }
                selectValue={associatedcontractid}
                handleSelectValueChange={handleAssociatedcontractidChange}
                data={utilitiesData}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={
                  compte.energy[energy][parameters].authorization
                }
                selectValue={authorizationid}
                handleSelectValueChange={handleAuthorizationidChange}
                data={authorizationData}
              />
            </div>
            {currentusertype == 1 &&
              <>
                <div>
                  <CustomSelect
                    inputTitle={
                      compte.energy[energy][parameters].utilityauthorization
                    }
                    selectValue={utilityauthorizationid}
                    handleSelectValueChange={handleUtilityauthorizationidChange}
                    data={utilityauthorizationData}
                  />
                </div>
              </>
            }
            <div>
              <AutocompleteInput
                specialWidth="97%"
                inputTitle={compte.energy[energy][parameters].associatedfiles}
                selected={selectedGed()}
                list={gedList}
                handleChange={(_, newValue) =>
                  handleAssociatedfilesChange(newValue)
                }
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].comments}
                textInput={comments}
                handleTextInputChange={handleCommentsChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.energy[energy][parameters].usagecode}
                textInput={usagecode}
                handleTextInputChange={handleUsagecodeChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <Button
              noWrap
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "0px",
                marginBottom: "0px",
                marginTop: "15px",
                fontFamily: '"Source Sans Pro",sans-serif',
                width: "96%",
                marginLeft: "2%",
              }}
              onClick={() => {
                handleSubmit();
              }}
            >
              Enregistrer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default EditUserDialog;
